import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "onboarding-books__covers" }
const _hoisted_2 = ["src"]

import { computed, onBeforeMount } from 'vue'

import { BooksChoice } from '@/models/onboarding.types'
import { getImage, QuestionnaireView } from '@/models/onboarding'

import Layout from './Layout.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'BooksDone',
  props: {
    view: {}
  },
  setup(__props: any) {

const props = __props

const books = computed(() => {
  const allBooks = props.view.currentChoice as BooksChoice | undefined
  if (!allBooks) {
    return []
  }

  return allBooks.filter((book) => book.score >= 0)
})

onBeforeMount(() => {
  props.view.showContinueButton()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, {
    class: "onboarding-books onboarding-books--done",
    title: "We added the books you like to your <span>Custom Library!</span>"
  }, {
    aboveTitle: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(books.value, (book, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: book.id,
            class: "onboarding-books__cover-wrapper",
            style: _normalizeStyle({ '--book-index': index })
          }, [
            _createElementVNode("img", {
              src: _unref(getImage)(`${book.id}.png`),
              width: "223",
              height: "298",
              alt: "",
              class: "onboarding-books__cover"
            }, null, 8, _hoisted_2)
          ], 4))
        }), 128))
      ])
    ]),
    _: 1
  }))
}
}

})